import React from 'react'
import List from './list'

const ProductCategories = props => (
  <List categoryType='product' {...props} />
)

export default ProductCategories
